import { GetProjectRolesResponse } from '@/app/types/Dtos/response';
import { aiApi } from '@/app/utils/aiApi';

export const getProjectRoles = () => aiApi.get<GetProjectRolesResponse>('v1/users/projectroles');
